/* eslint-env browser */
module.exports = self.FormData;



/*****************
 ** WEBPACK FOOTER
 ** ../~/form-data/lib/browser.js
 ** module id = 4
 ** module chunks = 0
 **/